<template>
  <!-- 移动端页脚 -->
  <div>
    <div class="mb_footer">
      <!-- <div class="footerItem">
        <img src="@/assets/images/0_icon_pho.png" alt="">
        info@seikaiyaku.com
      </div> -->
      <div class="footerItem">
        <img src="@/assets/images/0_icon_ema.png" alt="">
        info@seikaiyaku.com
      </div>
    </div>
    <div class="mb_banquan">
      <div class="item">{{ $t('footer.copyrightMb') }}</div>
    </div>


  </div>
</template>

<script>
export default {
  name: "mobileFootView"
}
</script>

<style scoped lang="less">
.mb_footer {
  height: 59px;
  background-color: #1a1c1d;
  color: white;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
  .footerItem {
    display: flex;
    justify-content: center;
    margin: 10px 0;

    img {
      width: 20px;
      height: 100%;
      margin-right: 8px;
    }
  }
}
.mb_banquan {
  color: #ccc;
  height: 60px;
  background-color: #1c1e1f;
  font-size: 12px;
  padding: 8px 0;
  box-sizing: border-box;
  .item {
    display: flex;
    justify-content: center;
  }

}
</style>
